import PageHero from "../components/PageHero";

function EsgeaPlatformAndChatbot() {
  return (
    <>
      <PageHero
        eyebrow="eSgEA"
        title="Training Platform and Chatbot"
        text="Digital tools supporting ESG awareness, training and responsible decision-making in the shipping industry."
      />

      <section className="section esgea-tool-section">
        <div className="esgea-tool-card">
          <div className="esgea-tool-image">
            <img
              src="/images/news/esgea/esgea-rollup-banner.jpg"
              alt="eSgEA Training Platform and Chatbot"
            />
          </div>

          <div className="esgea-tool-content">
            <span className="eyebrow">ESG in Shipping</span>

            <h2>Practical ESG learning and AI-assisted support for the shipping sector</h2>

            <p>
              The eSgEA project supports the shipping industry in its transition
              toward sustainability by helping professionals better understand ESG
              principles and how they can be applied in daily business practice.
              Through digital training and AI-supported guidance, the project aims
              to strengthen environmental responsibility, social awareness,
              transparency and good governance.
            </p>

            <p>
              The eSgEA training platform provides an online learning environment
              tailored to shipping professionals. Its training material focuses on
              sector-specific ESG barriers and promotes sustainability, social
              responsibility and governance-oriented thinking across different
              company roles and functions.
            </p>

            <p>
              The platform is designed to deepen understanding of complex ESG
              issues in shipping, cultivate a sustainability-oriented mindset and
              encourage action both at individual and organisational level. It also
              includes exercises that support reflection, discussion and practical
              behavioural change.
            </p>

            <p>
              Alongside the training platform, the eSgEA chatbot introduces an
              AI-powered support tool focused on the social pillar of ESG. It is
              designed to help collect employee concerns related to workplace
              well-being, whistleblowing and corruption, while also supporting
              management with structured guidance for possible corrective actions.
            </p>

            <div className="esgea-tool-actions">
              <a
                href="https://esgea.eu"
                target="_blank"
                rel="noreferrer"
                className="btn primary"
              >
                Visit the website
              </a>

              <a
                href="https://training.esgea.eu"
                target="_blank"
                rel="noreferrer"
                className="btn secondary"
              >
                Visit the platform
              </a>

              <a
                href="https://chatbot.esgea.eu"
                target="_blank"
                rel="noreferrer"
                className="btn secondary"
              >
                Visit the bot
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EsgeaPlatformAndChatbot;